// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Balance Transaction Report - Enterprise Corporate Design
   Matching GameManagement Theme
   ============================================ */

/* CSS Variables - Matching GameManagement Theme */
:root {
  --balance-report-bg: #f8f9fa;
  --balance-report-text: #000000;
  --balance-report-text-muted: #4a5568;
  --balance-report-border: rgba(135, 206, 235, 0.3);
  --light-sky-blue: #87ceeb;
  --light-red: #ff6b6b;
  --white: #ffffff;
  --navy-blue: #001f3f;
  --transition: all 0.2s ease;
}

/* ============================================
   Main Container
   ============================================ */
.BalanceTransactionReport_balanceTransactionReport__iHmNN {
  min-height: calc(100vh - 60px);
  background: var(--balance-report-bg);
  padding: 1.5rem;
  color: var(--balance-report-text);
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* ============================================
   Header
   ============================================ */
.BalanceTransactionReport_header__NR-uq {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.BalanceTransactionReport_headerLeft__lqJAy {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.BalanceTransactionReport_headerIcon__jozIg {
  color: var(--light-sky-blue);
}

.BalanceTransactionReport_title__Xu065 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--balance-report-text);
  margin: 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

/* ============================================
   Loading & Error States
   ============================================ */
.BalanceTransactionReport_loadingContainer__ABgVN {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.BalanceTransactionReport_spinner__c2dbZ {
  color: var(--light-sky-blue);
  animation: BalanceTransactionReport_spin__8POJz 1s linear infinite;
}

@keyframes BalanceTransactionReport_spin__8POJz {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.BalanceTransactionReport_errorAlert__o9moN {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--light-red);
  color: white;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.BalanceTransactionReport_errorAlert__o9moN svg {
  flex-shrink: 0;
}

/* ============================================
   Table Container
   ============================================ */
.BalanceTransactionReport_tableContainer__7Nq29 {
  background: var(--white);
  border: 1px solid var(--balance-report-border);
  border-radius: 0.5rem;
  overflow-x: auto;
  overflow-y: visible;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.BalanceTransactionReport_table__2z2cu {
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
}

.BalanceTransactionReport_table__2z2cu thead {
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  background-color: #000000;
  color: #ffffff;
}

.BalanceTransactionReport_table__2z2cu th {
  padding: 1rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  background-color: #000000;
  color: #ffffff;
  white-space: nowrap;
}

.BalanceTransactionReport_table__2z2cu tbody tr {
  border-bottom: 1px solid var(--balance-report-border);
  transition: var(--transition);
}

.BalanceTransactionReport_table__2z2cu tbody tr:hover {
  background: rgba(135, 206, 235, 0.05);
}

.BalanceTransactionReport_table__2z2cu tbody tr:last-child {
  border-bottom: none;
}

.BalanceTransactionReport_table__2z2cu td {
  padding: 1rem;
  font-size: 0.875rem;
  color: var(--balance-report-text);
  white-space: nowrap;
}

.BalanceTransactionReport_emptyState__NioQs {
  text-align: center;
  padding: 3rem 1rem;
  color: var(--balance-report-text-muted);
  font-style: italic;
}

/* ============================================
   Pagination
   ============================================ */
.BalanceTransactionReport_paginationContainer__vZ8qE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.5rem;
  padding: 1rem;
  background: var(--white);
  border: 1px solid var(--balance-report-border);
  border-radius: 0.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.BalanceTransactionReport_paginationLeft__4iReB,
.BalanceTransactionReport_paginationRight__F3jdh {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.BalanceTransactionReport_paginationCenter__aRtZ5 {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  flex: 1 1;
  justify-content: center;
}

.BalanceTransactionReport_paginationButton__96ROj {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--balance-report-border);
  border-radius: 0.375rem;
  color: var(--balance-report-text);
  cursor: pointer;
  transition: var(--transition);
}

.BalanceTransactionReport_paginationButton__96ROj:hover:not(:disabled) {
  background: rgba(135, 206, 235, 0.1);
  border-color: var(--light-sky-blue);
  color: var(--light-sky-blue);
}

.BalanceTransactionReport_paginationButton__96ROj:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.BalanceTransactionReport_paginationText__BX3g- {
  font-size: 0.875rem;
  color: var(--balance-report-text);
  white-space: nowrap;
}

.BalanceTransactionReport_paginationText__BX3g- strong {
  font-weight: 700;
  color: var(--light-sky-blue);
}

.BalanceTransactionReport_goToPageForm__HI2-- {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.BalanceTransactionReport_pageInput__Jf0bV {
  width: 60px;
  padding: 0.375rem 0.5rem;
  font-size: 0.875rem;
  border: 1px solid var(--balance-report-border);
  border-radius: 0.375rem;
  background: var(--white);
  color: var(--balance-report-text);
  transition: var(--transition);
  box-sizing: border-box;
}

.BalanceTransactionReport_pageInput__Jf0bV:focus {
  outline: none;
  border-color: var(--light-sky-blue);
  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);
}

.BalanceTransactionReport_goToPageButton__DdDe- {
  padding: 0.375rem 0.75rem;
  background: var(--light-sky-blue);
  color: var(--white);
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.BalanceTransactionReport_goToPageButton__DdDe-:hover {
  background: #6bb6d4;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);
}

.BalanceTransactionReport_goToPageButton__DdDe-:active {
  transform: translateY(0);
}

.BalanceTransactionReport_pageSizeSelector__fqvQa {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.BalanceTransactionReport_pageSizeSelect__l6AXX {
  padding: 0.375rem 0.5rem;
  font-size: 0.875rem;
  border: 1px solid var(--balance-report-border);
  border-radius: 0.375rem;
  background: var(--white);
  color: var(--balance-report-text);
  cursor: pointer;
  transition: var(--transition);
}

.BalanceTransactionReport_pageSizeSelect__l6AXX:focus {
  outline: none;
  border-color: var(--light-sky-blue);
  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);
}

/* ============================================
   Responsive Design - Tablet
   ============================================ */
@media (max-width: 1024px) {
  .BalanceTransactionReport_balanceTransactionReport__iHmNN {
    padding: 1.25rem;
  }

  .BalanceTransactionReport_title__Xu065 {
    font-size: 1.25rem;
  }

  .BalanceTransactionReport_table__2z2cu th,
  .BalanceTransactionReport_table__2z2cu td {
    padding: 0.875rem;
    font-size: 0.8125rem;
  }
}

/* ============================================
   Responsive Design - Mobile
   ============================================ */
@media (max-width: 768px) {
  .BalanceTransactionReport_balanceTransactionReport__iHmNN {
    padding: 1rem;
  }

  .BalanceTransactionReport_header__NR-uq {
    flex-direction: column;
    align-items: flex-start;
  }

  .BalanceTransactionReport_title__Xu065 {
    font-size: 1.125rem;
  }

  .BalanceTransactionReport_tableContainer__7Nq29 {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .BalanceTransactionReport_table__2z2cu {
    min-width: 800px;
  }

  .BalanceTransactionReport_table__2z2cu th,
  .BalanceTransactionReport_table__2z2cu td {
    padding: 0.75rem 0.5rem;
    font-size: 0.75rem;
  }

  .BalanceTransactionReport_paginationContainer__vZ8qE {
    flex-direction: column;
    align-items: stretch;
  }

  .BalanceTransactionReport_paginationCenter__aRtZ5 {
    flex-direction: column;
    gap: 0.75rem;
  }

  .BalanceTransactionReport_paginationLeft__4iReB,
  .BalanceTransactionReport_paginationRight__F3jdh {
    justify-content: center;
    width: 100%;
  }
}

/* ============================================
   Responsive Design - Small Mobile
   ============================================ */
@media (max-width: 480px) {
  .BalanceTransactionReport_balanceTransactionReport__iHmNN {
    padding: 0.75rem;
  }

  .BalanceTransactionReport_title__Xu065 {
    font-size: 1rem;
  }

  .BalanceTransactionReport_table__2z2cu {
    min-width: 700px;
  }

  .BalanceTransactionReport_table__2z2cu th,
  .BalanceTransactionReport_table__2z2cu td {
    padding: 0.625rem 0.375rem;
    font-size: 0.6875rem;
  }

  .BalanceTransactionReport_paginationText__BX3g- {
    font-size: 0.75rem;
  }

  .BalanceTransactionReport_pageInput__Jf0bV {
    width: 50px;
    font-size: 0.75rem;
  }

  .BalanceTransactionReport_goToPageButton__DdDe- {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
  }

  .BalanceTransactionReport_pageSizeSelect__l6AXX {
    font-size: 0.75rem;
  }
}

/* ============================================
   Accessibility
   ============================================ */
@media (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}

.BalanceTransactionReport_paginationButton__96ROj:focus-visible,
.BalanceTransactionReport_pageInput__Jf0bV:focus-visible,
.BalanceTransactionReport_goToPageButton__DdDe-:focus-visible,
.BalanceTransactionReport_pageSizeSelect__l6AXX:focus-visible {
  outline: 2px solid var(--light-sky-blue);
  outline-offset: 2px;
}

`, "",{"version":3,"sources":["webpack://./src/styles/BalanceTransactionReport.module.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,kDAAkD;AAClD;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,iDAAiD;EACjD,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;;iDAEiD;AACjD;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,eAAe;EACf,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,kEAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,wBAAwB;EACxB,8CAA8C;EAC9C,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0EAA0E;EAC1E,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,0EAA0E;EAC1E,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,8CAA8C;EAC9C,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,8CAA8C;EAC9C,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,sCAAsC;IACtC,qCAAqC;EACvC;AACF;;AAEA;;;;EAIE,wCAAwC;EACxC,mBAAmB;AACrB","sourcesContent":["/* ============================================\n   Balance Transaction Report - Enterprise Corporate Design\n   Matching GameManagement Theme\n   ============================================ */\n\n/* CSS Variables - Matching GameManagement Theme */\n:root {\n  --balance-report-bg: #f8f9fa;\n  --balance-report-text: #000000;\n  --balance-report-text-muted: #4a5568;\n  --balance-report-border: rgba(135, 206, 235, 0.3);\n  --light-sky-blue: #87ceeb;\n  --light-red: #ff6b6b;\n  --white: #ffffff;\n  --navy-blue: #001f3f;\n  --transition: all 0.2s ease;\n}\n\n/* ============================================\n   Main Container\n   ============================================ */\n.balanceTransactionReport {\n  min-height: calc(100vh - 60px);\n  background: var(--balance-report-bg);\n  padding: 1.5rem;\n  color: var(--balance-report-text);\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n/* ============================================\n   Header\n   ============================================ */\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.headerIcon {\n  color: var(--light-sky-blue);\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--balance-report-text);\n  margin: 0;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n/* ============================================\n   Loading & Error States\n   ============================================ */\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.spinner {\n  color: var(--light-sky-blue);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.errorAlert {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: var(--light-red);\n  color: white;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.errorAlert svg {\n  flex-shrink: 0;\n}\n\n/* ============================================\n   Table Container\n   ============================================ */\n.tableContainer {\n  background: var(--white);\n  border: 1px solid var(--balance-report-border);\n  border-radius: 0.5rem;\n  overflow-x: auto;\n  overflow-y: visible;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 900px;\n}\n\n.table thead {\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  background-color: #000000;\n  color: #ffffff;\n}\n\n.table th {\n  padding: 1rem;\n  text-align: left;\n  font-size: 0.875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  background-color: #000000;\n  color: #ffffff;\n  white-space: nowrap;\n}\n\n.table tbody tr {\n  border-bottom: 1px solid var(--balance-report-border);\n  transition: var(--transition);\n}\n\n.table tbody tr:hover {\n  background: rgba(135, 206, 235, 0.05);\n}\n\n.table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.table td {\n  padding: 1rem;\n  font-size: 0.875rem;\n  color: var(--balance-report-text);\n  white-space: nowrap;\n}\n\n.emptyState {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: var(--balance-report-text-muted);\n  font-style: italic;\n}\n\n/* ============================================\n   Pagination\n   ============================================ */\n.paginationContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 1.5rem;\n  padding: 1rem;\n  background: var(--white);\n  border: 1px solid var(--balance-report-border);\n  border-radius: 0.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.paginationLeft,\n.paginationRight {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.paginationCenter {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  flex: 1;\n  justify-content: center;\n}\n\n.paginationButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  background: transparent;\n  border: 1px solid var(--balance-report-border);\n  border-radius: 0.375rem;\n  color: var(--balance-report-text);\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.paginationButton:hover:not(:disabled) {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: var(--light-sky-blue);\n  color: var(--light-sky-blue);\n}\n\n.paginationButton:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.paginationText {\n  font-size: 0.875rem;\n  color: var(--balance-report-text);\n  white-space: nowrap;\n}\n\n.paginationText strong {\n  font-weight: 700;\n  color: var(--light-sky-blue);\n}\n\n.goToPageForm {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pageInput {\n  width: 60px;\n  padding: 0.375rem 0.5rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--balance-report-border);\n  border-radius: 0.375rem;\n  background: var(--white);\n  color: var(--balance-report-text);\n  transition: var(--transition);\n  box-sizing: border-box;\n}\n\n.pageInput:focus {\n  outline: none;\n  border-color: var(--light-sky-blue);\n  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);\n}\n\n.goToPageButton {\n  padding: 0.375rem 0.75rem;\n  background: var(--light-sky-blue);\n  color: var(--white);\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.goToPageButton:hover {\n  background: #6bb6d4;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);\n}\n\n.goToPageButton:active {\n  transform: translateY(0);\n}\n\n.pageSizeSelector {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pageSizeSelect {\n  padding: 0.375rem 0.5rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--balance-report-border);\n  border-radius: 0.375rem;\n  background: var(--white);\n  color: var(--balance-report-text);\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.pageSizeSelect:focus {\n  outline: none;\n  border-color: var(--light-sky-blue);\n  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);\n}\n\n/* ============================================\n   Responsive Design - Tablet\n   ============================================ */\n@media (max-width: 1024px) {\n  .balanceTransactionReport {\n    padding: 1.25rem;\n  }\n\n  .title {\n    font-size: 1.25rem;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.875rem;\n    font-size: 0.8125rem;\n  }\n}\n\n/* ============================================\n   Responsive Design - Mobile\n   ============================================ */\n@media (max-width: 768px) {\n  .balanceTransactionReport {\n    padding: 1rem;\n  }\n\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .title {\n    font-size: 1.125rem;\n  }\n\n  .tableContainer {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table {\n    min-width: 800px;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.75rem;\n  }\n\n  .paginationContainer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .paginationCenter {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .paginationLeft,\n  .paginationRight {\n    justify-content: center;\n    width: 100%;\n  }\n}\n\n/* ============================================\n   Responsive Design - Small Mobile\n   ============================================ */\n@media (max-width: 480px) {\n  .balanceTransactionReport {\n    padding: 0.75rem;\n  }\n\n  .title {\n    font-size: 1rem;\n  }\n\n  .table {\n    min-width: 700px;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.625rem 0.375rem;\n    font-size: 0.6875rem;\n  }\n\n  .paginationText {\n    font-size: 0.75rem;\n  }\n\n  .pageInput {\n    width: 50px;\n    font-size: 0.75rem;\n  }\n\n  .goToPageButton {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.5rem;\n  }\n\n  .pageSizeSelect {\n    font-size: 0.75rem;\n  }\n}\n\n/* ============================================\n   Accessibility\n   ============================================ */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition-duration: 0.01ms !important;\n    animation-duration: 0.01ms !important;\n  }\n}\n\n.paginationButton:focus-visible,\n.pageInput:focus-visible,\n.goToPageButton:focus-visible,\n.pageSizeSelect:focus-visible {\n  outline: 2px solid var(--light-sky-blue);\n  outline-offset: 2px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"balanceTransactionReport": `BalanceTransactionReport_balanceTransactionReport__iHmNN`,
	"header": `BalanceTransactionReport_header__NR-uq`,
	"headerLeft": `BalanceTransactionReport_headerLeft__lqJAy`,
	"headerIcon": `BalanceTransactionReport_headerIcon__jozIg`,
	"title": `BalanceTransactionReport_title__Xu065`,
	"loadingContainer": `BalanceTransactionReport_loadingContainer__ABgVN`,
	"spinner": `BalanceTransactionReport_spinner__c2dbZ`,
	"spin": `BalanceTransactionReport_spin__8POJz`,
	"errorAlert": `BalanceTransactionReport_errorAlert__o9moN`,
	"tableContainer": `BalanceTransactionReport_tableContainer__7Nq29`,
	"table": `BalanceTransactionReport_table__2z2cu`,
	"emptyState": `BalanceTransactionReport_emptyState__NioQs`,
	"paginationContainer": `BalanceTransactionReport_paginationContainer__vZ8qE`,
	"paginationLeft": `BalanceTransactionReport_paginationLeft__4iReB`,
	"paginationRight": `BalanceTransactionReport_paginationRight__F3jdh`,
	"paginationCenter": `BalanceTransactionReport_paginationCenter__aRtZ5`,
	"paginationButton": `BalanceTransactionReport_paginationButton__96ROj`,
	"paginationText": `BalanceTransactionReport_paginationText__BX3g-`,
	"goToPageForm": `BalanceTransactionReport_goToPageForm__HI2--`,
	"pageInput": `BalanceTransactionReport_pageInput__Jf0bV`,
	"goToPageButton": `BalanceTransactionReport_goToPageButton__DdDe-`,
	"pageSizeSelector": `BalanceTransactionReport_pageSizeSelector__fqvQa`,
	"pageSizeSelect": `BalanceTransactionReport_pageSizeSelect__l6AXX`
};
export default ___CSS_LOADER_EXPORT___;
